<template lang="pug">
	.enroll-now-component(v-if="ready" :class="{'orange': orange, 'sfc-small-button': isSmallButton}")
		b-btn.d-none(v-b-modal.enroll-now-modal ref="modalTrigger")

		.action-wrapper(v-if="computedFindAPro && !computedPlan.has_enroll_now")
			a.btn.sfc-en-button(
				href="/find_a_529_pro/"
				@click="trackFindAProClick($event)"
				:class="{empty: !isPrimaryAction}"
				data-cta-type="find-a-pro"
			)
				| Find a Pro

		.d-inline-block.action-wrapper(v-if="!specialPlan && !computedFindAPro")
			a.btn.sfc-en-button.sfc-enroll-now-button(
				v-if="computedPlan.has_enroll_now"
				:data-cta-type="setDataCtaTypeAttributeForEnrollNow()"
				v-bind:class="{'btn-block': fullWidth === true}"
				target="_blank"
				:href="enrollNowUrl"
				:data-user-target="userTarget"
				@click="handleEnrollNowButtonClick($event)"
				name="enroll_now"
				:rel="hasNoFollow(computedPlan.enroll_now_destination_url)"
			)
				span(v-if="!this.showCtaPlacementVariant")
					| {{ $t("enroll_now") }}
				span(v-else)
					| Get Started
				img(v-if="computedPlan.tracking_pixel_url" style="width:1px; height:1px;" :src="computedPlan.tracking_pixel_url")
				
			.secure-message.text-nowrap(v-if="computedPlan.has_enroll_now && showEnrollNowCount")
				span(v-if="isSmallButton")
					| {{computedPlan.enroll_now_count || '0' | currency('',0)}} {{ $t("clicked") }}
				span(v-else-if="this.showCtaPlacementVariant")
					| {{computedPlan.enroll_now_count || '0' | currency('',0)}} Clicked to Get Started
				span(v-else)
					| {{computedPlan.enroll_now_count || '0' | currency('',0)}} {{ $t("clicked_to_enroll") }}
			.secure-message(v-if="computedPlan.has_enroll_now && !showEnrollNowCount && showSecure")
				span
					| On this plan's secure website

			a.btn.sfc-en-button.sfc-enroll-now-button(v-if="!computedPlan.has_enroll_now && !computedFindAPro && computedPlan.url && computedPlan.is_direct_sold" v-bind:class="{'btn-block':(fullWidth == true)}" target="_blank" :href="`/interstitial?plan_id=${plan.id}`" @click="setTakeoverInfo();trackTrialEnrollNowClick()" name="trial_enroll_now" :rel="hasNoFollow(computedPlan.enroll_now_destination_url)")
				span(v-if="!this.showCtaPlacementVariant")
					| {{ $t("enroll_now") }}
				span(v-else)
					| Get Started
				img(v-if="computedPlan.tracking_pixel_url" style="width:1px; height:1px;" :src="computedPlan.tracking_pixel_url")

				a.btn.sfc-en-button.plan-details(
					v-if="!computedPlan.has_enroll_now && !computedFindAPro && !computedPlan.url && !planDetailsShowLink"
					data-cta-type="plan-details"
					:href="computedPlan.plan_details_url"
					@click="trackLearnMoreClick({ event: $event, designVersion: 'old_cta' })"
					name="plan_details"
					:target="linkTarget"
					:rel="hasNoFollow(computedPlan.enroll_now_destination_url)"
				) 
					| {{ $t("plan_details") }}


			.plan-details-link
				a.plan-details(
					data-cta-type="plan-details"
					v-if="!computedPlan.has_enroll_now && !computedFindAPro && !computedPlan.url && planDetailsShowLink"
					:href="computedPlan.plan_details_url"
					@click="trackLearnMoreClick({ event: $event, designVersion: 'text_link'})"
					name="plan_details"
					:target="linkTarget"
				)
					| {{ $t("plan_details") }}

</template>
<style lang="stylus" scoped>
@import '~assets/css/redesign-v1/variables.styl'

.enroll-now-component
	.action-wrapper
		width: 100%
		display: block
		a
			width: 100%

.sfc-small-button
	button.sfc-en-button
	a.sfc-en-button
		padding-left 0px !important
		padding-right 0px !important
a.btn
	&.sfc-en-button
		padding: 12px 20px
		font-size: body-font-size-md
		text-transform: uppercase
		margin: 0
		border: 0
		background: blue-primary
		color #fff !important
		text-transform uppercase
		border-radius(22px)
		font-weight: body-font-weight-strong
		line-height: normal
		&:hover
			background: blue-hover
		&.empty
			padding: 10px 20px
			background: #fff
			color: blue-primary !important
			border: 2px solid blue-primary
			box-shadow: unset
			border-radius(4px)
			&:hover
				color: blue-hover !important
				border-color: blue-hover

.secure-message
	clear: both
	font-size: body-font-size-xs + 1
	font-weight: body-font-weight-medium
	color: gray-70
	margin-top: 16px
	line-height: normal
	@media (min-width: 768px) and (max-width: 991px)
		margin-top: 22px

@media (max-width: 1200px)
	button.sfc-en-button
	a.sfc-en-button
		padding-left 0px
		padding-right 0px
.orange
	.sfc-enroll-now-button
		border-color: orange-secondary!important
		background-color: orange-secondary !important
		&:hover
			background-color: orange-hover !important

.plan-details-link
	text-align: center
	a.plan-details
		text-decoration: underline
</style>
<script>
import SfcTrackingService from '@/lib/sfc-tracking-service'
import { getCpeExperimentVariant, getUrlToCPEIfConditionsAreMet } from '@/lib/cpe-experiment-utils'

const NC_529_PLAN_ID = 39

export default {
	async created() {
		if (this.page == `plan details` && this.params && this.params.planSelectionWizard) {
			this.specialButtonUrl = 'https://collegebacker.com/origin/sfc-enroll-other'
		} else {
			this.specialButtonUrl = 'https://collegebacker.com/origin/sfc-enroll'
		}

		// If it is find a pro, don't do anything else
		if (this.findAPro) {
			this.ready = true
			return
		}

		if (!this.page) {
			this.sendAlert = true
			this.alertMessage += `Enroll now component -> No page specified. `
			this.page = this.url
		}

		if (this.plan) {
			// We need to check if we have all fields to make it robust
			if (this.plan.id) {
				// False on purpose, This was collegebacker, and now it is a skeleton in case we add another paid plan
				if (false) {
					this.specialPlan = true
				}
			} else {
				this.sendAlert = true
				this.alertMessage += `Enroll now component -> given plan without id. `
			}

			if (!this.plan.name) {
				this.sendAlert = true
				this.alertMessage += 'Enroll now component -> given plan without name. '
				if (this.plan.id) {
					this.plan.name = 'Plan id: ${this.plan.name}'
				} else {
					this.plan.name = 'Unknown Plan: ${this.plan.plan_details_url}'
				}
			}

			if (this.plan.has_enroll_now) {
				if (!this.plan.enroll_now_url) {
					this.sendAlert = true
					this.alertMessage += 'Enroll now component -> given plan without enroll now url. '
					this.plan.has_enroll_now = false

					if (this.showEnrollNowCount) {
						if (!this.plan.enroll_now_count) {
							this.sendAlert = true
							this.alertMessage += 'Enroll now component -> given plan without enroll now count. '
							this.showEnrollNowCount = false
						}
					}
				}
			}

			if (!this.plan.has_enroll_now) {
				if (!this.plan.plan_details_url) {
					this.sendAlert = true
					this.alertMessage += 'Enroll now component -> given plan without plan details url. '
					this.forceFindAPro = true
				}
			}

			if (
				!this.plan.state_object ||
				!this.plan.state_object.id ||
				!this.plan.state_object.name ||
				!this.plan.state_object.sfc_id ||
				!this.plan.state_object.slug
			) {
				const query = `
					query {
							plan(id: ${this.plan.id}, click_source:"${this.clickSource}"){
								state_object {
									id
									name
									sfc_id
									slug
								}
							}
						}
					`
				try {
					const response = await this.$httpService.graphql(query)
					if (this.plan.state_object) {
						this.plan.state_object.id = response.data.plan.state_object.id
						this.plan.state_object.name = response.data.plan.state_object.name
						this.plan.state_object.sfc_id = response.data.plan.state_object.sfc_id
						this.plan.state_object.slug = response.data.plan.state_object.slug
					} else {
						this.plan.state_object = response.data.plan.state_object
					}
				} catch (e) {
					console.error(e)
				}
			}

			this.ready = true
		} else {
			if (!this.planId) {
				this.sendAlert = true
				this.alertMessage += 'Enroll now component -> No plan id. '
				// fall back to show at least something
				this.forceFindAPro = true
				this.ready = true
				this.sendWarningAlert()
				return
			}

			if (this.clickSource == undefined) {
				this.sendAlert = true
				this.alertMessage += 'Enroll now component -> No click source. '
				this.clickSource = 'sfc_spa_undefined_source'
			}

			const query = `
				query {
					no_graphql_cache()
					plan(id: ${this.planId}, click_source:"${this.clickSource}"){
						id
						name
						has_enroll_now
						enroll_now_count
						plan_details_url
						investment_options_url
						enroll_now_url
						tracking_pixel_url
						enroll_now_destination_url
					}
				}
			`
			try {
				const response = await this.$httpService.graphql(query)
				this.planFromApi = response.data.plan
				this.ready = true
			} catch (e) {
				this.sendAlert = true
				this.alertMessage += 'Enroll now component -> call to api failed. '
			}
		}

		if (this.plan) {
			this.cpeVariant = await getCpeExperimentVariant(this.plan.id, this.$cookies, this.$store)
		}

		if (this.sendAlert) {
			this.sendWarningAlert()
		}
	},
	data() {
		return {
			ready: false,
			alertMessage: ``,
			specialButtonUrl: ``,
			specialPlan: ``,
			url: ``,
			planFromApi: {},
			forceFindAPro: false,
			cpeVariant: null,
			userTarget: 'plan_site'
		}
	},

	props: {
		designVersion: String,
		clickSource: String,
		contextPlacement: String,
		customEnrollNowUrl: String,
		findAPro: Boolean,
		fullWidth: Boolean,
		isPrimaryAction: Boolean,
		isSmallButton: Boolean,
		orange: Boolean,
		page: String,
		params: Object,
		plan: Object,
		planDetailsShowLink: Boolean,
		planId: String,
		showEnrollNowCount: Boolean,
		showSecure: Boolean,
		target: String,
		showCtaPlacementVariant: Boolean
	},

	methods: {
		handleEnrollNowButtonClick(event) {
			this.setTakeoverInfo()
			this.trackEnrollNowClick(event)

			const fbq = window && window.fbq
			if (fbq && this.plan) {
				fbq('track', 'Purchase', {
					content_ids: [this.plan.id],
					content_name: this.plan.name,
					content_type: 'plan',
					value: this.plan.id === NC_529_PLAN_ID ? 7.5 : 0.0,
					currency: 'USD'
				})
			}
		},
		setTakeoverInfo() {
			const info = {
				type: 'enroll-now',
				planId: 22,
				stateName: this.plan.state_object.name,
				stateURL: `/529-plans/${this.plan.state_object.slug}`,
				cardImageURL:
					'https://web-resources.savingforcollege.com/images/en-merril-interstitial-red.png',
				redButtonVersion: true
			}

			if (this.plan.id == 22) {
				info.planId = 77
				info.cardImageURL =
					'https://web-resources.savingforcollege.com/images/en-t-rowe-takeover-red.png'
				info.redButtonVersion = true
			}
			this.$store.commit('updateTakeoverInfo', info)
		},
		setDataCtaTypeAttributeForEnrollNow() {
			// do not set element_index for fixed elements
			return this.contextPlacement !== 'fixed' ? 'enroll-now' : 'enroll-now-fixed'
		},
		trackEnrollNowClick(event) {
			SfcTrackingService.trackEnrollNowClick({
				page: this.page,
				plan: this.plan,
				contextPlacement: this.contextPlacement,
				clickSource: this.clickSource,
				designVersion: this.designVersion,
				elementIndex: Number(event.target.getAttribute('element_index'))
			})
			this.emitCallback('enrollNowCallback')
		},
		trackTrialEnrollNowClick() {
			SfcTrackingService.trackTrialEnrollNowClick(this.page, this.plan.name)
			this.emitCallback('trialEnrollNowCallback')
		},
		trackFindAProClick(event) {
			SfcTrackingService.trackFindAProClick({
				page: this.page,
				version: this.$store.state.config.planDetailsPageVersion,
				plan: this.plan,
				contextPlacement: this.contextPlacement,
				clickSource: this.clickSource,
				elementIndex: Number(event.target.getAttribute('element_index')),
				designVersion: this.designVersion
			})
			this.emitCallback('findAProCallback')
		},
		trackLearnMoreClick({ event, designVersion }) {
			SfcTrackingService.trackPlanDetailsClick({
				page: this.page,
				plan: this.plan,
				contextPlacement: this.contextPlacement,
				clickSource: this.clickSource,
				elementIndex: Number(event.target.getAttribute('element_index')),
				designVersion
			})

			SfcTrackingService.trackLearnMoreClick(
				this.page,
				`${this.$store.state.config.planDetailsPageVersion}`,
				this.plan.name
			)
			this.emitCallback('learnMoreCallback')
		},

		emitCallback(methodToEmit) {
			this.$emit(methodToEmit)
		},

		async sendWarningAlert() {
			if (process.browser) {
				if (!window.location.pathname.includes('article-preview')) {
					console.error(this.alertMessage)
					console.error(this.url)
				}
			}
		},

		hasNoFollow(en_link_redirect) {
			//to follow any enroll now link, you must add it to the list
			let list_nofollow = [' ']
			if (en_link_redirect) {
				for (var i = 0;i < list_nofollow.length;i++) {
					if (en_link_redirect.includes(list_nofollow[i])) {
						return ''
					}
				} //Default: nofollow
				return 'nofollow'
			} else {
				return ''
			}
		}
	},
	computed: {
		// a computed getter
		computedPlan() {
			if (this.plan) {
				if (this.clickSource && this.plan.enroll_now_url) {
					this.plan.enroll_now_url = this.plan.enroll_now_url.replace(
						/(&|\?)click_source=[^&]+/,
						'$1click_source=' + this.clickSource
					)
				}
				return this.plan
			}
			return this.planFromApi
		},
		computedFindAPro() {
			return this.findAPro || this.forceFindAPro
		},
		linkTarget() {
			if (this.target) {
				return this.target
			}
			return '_self'
		},
		enrollNowUrl() {
			let plan = undefined
			let clickSource

			if (this.$props.customEnrollNowUrl) {
				return this.$props.customEnrollNowUrl
			}

			if (this.plan) {
				plan = this.plan
			}

			if (this.planFromApi && this.planFromApi.id) {
				plan = this.planFromApi
			}

			if (this.clickSource) {
				clickSource = this.clickSource
			} else {
				clickSource = 'missing'
			}

			if (plan && plan.id) {
				const url = getUrlToCPEIfConditionsAreMet(this.cpeVariant, plan.id)
				if (url) {
					this.userTarget = 'cpe'
					return url
				}

				return `/enroll_in_a_529_plan/index.php?page=online&track=normal&plan_id=${plan.id
					}&click_source=${clickSource}`
			}

			if (this.ready) {
				this.sendWarningAlert()
			}

			return ''
		}
	}
}
</script>
